let cachePrefetch = {};
addEventListener("turbo:before-prefetch", (event) => {
	let href = event.srcElement?.getAttribute("href");

	if (href) {
		let time = new Date().getTime();

		if (
			typeof cachePrefetch[href] !== 'undefined'
			&& (time - cachePrefetch[href]) < 4 * 1000
		) {
			event.preventDefault()
		}

		cachePrefetch[href] = time;
	}

	if (hasSlowInternet()) {
		event.preventDefault()
	}
});

function hasSlowInternet() {
	let etype = navigator.connection?.effectiveType;
	return etype === "slow-2g"
		|| etype === "2g"
}
